import * as z from "zod";

const conversationSourceSchema = z.object({
  topicId: z.string(),
  hasSupportTicket: z.boolean(),
  hasCommerceAgentConversation: z.boolean(),
  campaignId: z.string().nullable(),
  automationId: z.string().nullable(),
  automationStepId: z.string().nullable(),
  primaryTriggerKey: z.string().nullable(),
});

export type ShopperAgentConversationSource = z.infer<
  typeof conversationSourceSchema
>;

/**
 * Where a conversation lives in the merchant app: one entry per support,
 * Commerce Agent or outreach topic on the channel thread. The outreach fields
 * are for admin apps from before the trace carried each outreach's source.
 */
export const getShopperAgentConversationSources = {
  name: "getShopperAgentConversationSources" as const,
  input: z.object({ channelThreadId: z.string() }),
  output: z.object({
    teamId: z.string(),
    sources: z.array(conversationSourceSchema),
  }),
};

export type GetShopperAgentConversationSourcesOutput = z.infer<
  typeof getShopperAgentConversationSources.output
>;
